import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LockKeyholeCircle = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "lock-keyhole-circle",
    className: clsx('stroke-current', className)
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"
    }), /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.7316 13.1947c-.0706-.2116-.1059-.3175-.104-.404.0019-.0911.0141-.1388.056-.2196.0399-.0769.1464-.1761.3596-.3744C14.6318 11.649 15 10.8675 15 10c0-1.6569-1.3431-3-3-3s-3 1.3431-3 3c0 .8675.3682 1.649.9568 2.1967.2132.1983.3197.2975.3596.3744.0419.0808.0541.1285.056.2196.0019.0865-.0334.1924-.104.404L9.351 15.947c-.1185.3555-.1778.5333-.1422.6748a.5003.5003 0 0 0 .216.2998C9.5478 17 9.7352 17 10.11 17h3.7802c.3747 0 .5621 0 .6851-.0784a.5004.5004 0 0 0 .216-.2998c.0356-.1415-.0237-.3193-.1422-.6748l-.9174-2.7523Z"
    })]
  }));
};
export default LockKeyholeCircle;